var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBugLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 16.583a4.168 4.168 0 0 0 3.334-4.083V10a4.15 4.15 0 0 0-.347-1.667H6.18A4.15 4.15 0 0 0 5.832 10v2.5a4.168 4.168 0 0 0 3.334 4.083v-4.916h1.666v4.916Zm-6.22-1.84a5.816 5.816 0 0 1-.446-2.243h-2.5v-1.667h2.5V10c0-.536.072-1.054.207-1.547L2.53 7.388l.833-1.443 1.684.972c.053-.085.108-.168.165-.25h9.576c.057.082.112.165.165.25l1.684-.972.833 1.443-1.844 1.065c.135.493.207 1.011.207 1.547v.833h2.5V12.5h-2.5c0 .794-.159 1.552-.446 2.242l2.083 1.203-.833 1.443-2.105-1.215A5.822 5.822 0 0 1 10 18.333a5.822 5.822 0 0 1-4.532-2.16l-2.105 1.215-.833-1.443 2.083-1.203ZM6.667 5a3.333 3.333 0 1 1 6.666 0H6.667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBugLine);
export default __webpack_public_path__ + "static/media/bug-line.b57eed6504d136a2df4760ec294876dd.svg";
export { ForwardRef as ReactComponent };